// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { database as realtimeDb } from "../FirebaseConfig"; // Import Firebase Realtime DB
// import { ref, onValue } from "firebase/database";
// import { Link } from "react-router-dom"; // For navigation

// const AnnouncementCarousel = () => {
//   const [announcements, setAnnouncements] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const announcementsRef = ref(realtimeDb, "announcements");

//     // Fetch announcements from Firebase Realtime Database
//     const unsubscribe = onValue(announcementsRef, (snapshot) => {
//       if (snapshot.exists()) {
//         const data = Object.values(snapshot.val()); // Convert Firebase object to array
//         setAnnouncements(data);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (announcements.length > 0) {
//       const interval = setInterval(() => {
//         setCurrentIndex((prevIndex) =>
//           prevIndex === announcements.length - 1 ? 0 : prevIndex + 1
//         );
//       }, 3000); // Change announcement every 3 seconds

//       return () => clearInterval(interval);
//     }
//   }, [announcements]);

//   if (announcements.length === 0) {
//     return null; // Don't render if no announcements are available
//   }

//   return (
//     <div 
//       style={{
//         backgroundColor: announcements[currentIndex]?.bgColor || "#f47d02",
//       }}
//       className="w-full fixed top-0 text-center left-0 z-50   overflow-hidden"
//     >
//       <div className="relative h-8 flex items-center justify-center">
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={currentIndex}
//             initial={{ y: 20, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             exit={{ y: -20, opacity: 0 }}
//             transition={{ duration: 0.5 }}
//             className="text-sm sm:text-size-4 font-semibold flex items-center space-x-2"
//             style={{ color: announcements[currentIndex]?.textColor || "#fff" }}
//           >
//             <Link
//               to={announcements[currentIndex]?.link || "#"}
//               className="flex text-xs md:text-sm items-center space-x-2 hover:underline"
//             >
//               <span>{announcements[currentIndex]?.text}</span>
//               {/* {announcements[currentIndex]?.icon && (
//                 <img
//                   src={announcements[currentIndex]?.icon}
//                   alt="icon"
//                   className="h-4 w-4"
//                 />
//               )} */}
//             </Link>
//           </motion.div>
//         </AnimatePresence>
//       </div>
//     </div>
//   );
// };

// export default AnnouncementCarousel;


import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { database as realtimeDb } from "../FirebaseConfig";
import { ref, onValue } from "firebase/database";
import { Link } from "react-router-dom";

const AnnouncementCarousel = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isExpanding, setIsExpanding] = useState(false);
  const [hasIntroRan, setHasIntroRan] = useState(true); // Default to true to prevent flicker

  useEffect(() => {
    // Check if it's a new session
    const seen = sessionStorage.getItem("announcementIntroSeen");
    if (!seen) {
      setHasIntroRan(false);
      // Trigger the expansion after a short delay
      setTimeout(() => {
        setIsExpanding(true);
        // sessionStorage.setItem("announcementIntroSeen", "true");
      }, 800);
    } else {
      setIsExpanding(true);
    }

    const announcementsRef = ref(realtimeDb, "announcements");
    return onValue(announcementsRef, (snapshot) => {
      if (snapshot.exists()) {
        setAnnouncements(Object.values(snapshot.val()));
      }
    });
  }, []);

  useEffect(() => {
    if (announcements.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev === announcements.length - 1 ? 0 : prev + 1));
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [announcements]);

  if (announcements.length === 0) return null;

  const currentItem = announcements[currentIndex];

  return (
    <motion.div
      initial={hasIntroRan ? { height: "2.25rem", width: "100%" } : { height: "40px", width: "150px", y: 20, borderRadius: "50px", opacity: 0 }}
      animate={isExpanding ? { 
        height: "2.25rem", 
        width: "100%", 
        y: 0, 
        borderRadius: "0px", 
        opacity: 1 
      } : {}}
      transition={{ type: "spring", stiffness: 100, damping: 15 }}
      style={{
        backgroundColor: currentItem?.bgColor || "#f47d02",
      }}
      className="fixed top-0 left-0 right-0 z-50 overflow-hidden flex items-center justify-center shadow-lg mx-auto"
    >
      {/* Animated Background Shimmer */}
      <motion.div 
        animate={{ x: ["-100%", "100%"] }}
        transition={{ repeat: Infinity, duration: 3, ease: "linear" }}
        className="absolute inset-0 w-1/2 h-full skew-x-12 bg-white/10 pointer-events-none blur-xl"
      />

      <div className="relative w-full h-full flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, scale: 0.9, filter: "blur(4px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            exit={{ opacity: 0, scale: 1.1, filter: "blur(4px)" }}
            transition={{ duration: 0.4 }}
            className="w-full text-center"
          >
            <Link
              to={currentItem?.link || "#"}
              className="group relative inline-flex items-center justify-center px-6 py-1"
              style={{ color: currentItem?.textColor || "#fff" }}
            >
              {/* The Text with a subtle "pulse" logic */}
              <motion.span 
                animate={!hasIntroRan ? { scale: [1, 1.05, 1] } : {}}
                transition={{ repeat: 3, duration: 1 }}
                className="text-xs md:text-sm font-bold tracking-wide flex items-center gap-2"
              >
                {currentItem?.text}
                
                {/* Visual Cue: An arrow that "peeks" on hover */}
                <motion.span
                  className="inline-block"
                  initial={{ x: -5, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.5 }}
                >
                  <ArrowIcon />
                </motion.span>
              </motion.span>

              {/* Hover Glow Effect */}
              <span className="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-colors duration-300 rounded-md" />
            </Link>
          </motion.div>
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

// Simple clean SVG icon
const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14m-7-7 7 7-7 7"/>
  </svg>
);

export default AnnouncementCarousel;